import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {NoBuildingsModalComponent} from './no-buildings-modal.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [
        NoBuildingsModalComponent
    ],
    exports: [
        NoBuildingsModalComponent
    ]
})
export class NoBuildingsModalModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/no-buildings-modal/no-buildings-modal.module.ts